// extracted by mini-css-extract-plugin
module.exports = {"primary":"#306293","accent":"#e91e63","secondary":"#30b1dc","tertiary":"#2199c2","success":"#5794d0","info":"#2196f3","warning":"#fb8c00","danger":"#fb8c00","error":"#ff5252"};